module.exports = __webpack_public_path__ + "img/icon_like-fill.e33c3ed5.svg";